const initialState = {
    data: null,
};
export const getSharedWithMeRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'GETSHAREDWITHME_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETSHAREDWITHME_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default getSharedWithMeRedux;